import { createAction, props } from '@ngrx/store';
import { ActionTypes } from './action-types';
import { CompanySettings } from "../get-company-settings.service";

export const getCompanySettingsAction = createAction(
  ActionTypes.GET_COMPANY_SETTINGS
);

export const getCompanySettingsSuccessAction = createAction(
  ActionTypes.GET_COMPANY_SETTINGS_SUCCESS,
  props<{ data: CompanySettings | undefined }>()
);

export const getCompanySettingsFailureAction = createAction(
  ActionTypes.GET_COMPANY_SETTINGS_FAILURE,
  props<{ error: unknown }>()
);
